export enum SubscriptionBillingForEnum {
  ACTIVE_DAYS = 'active_days',
  ENTIRE_PERIOD = 'entire_period'
}
